import request from '@/api/config/request'

const prex = "api/admin/nfse_importadas";

export function listNotasImportadasAdmin(query = {}) {
    return request({
        url: `${prex}/lista`,
        method: 'get',
        params: query
    })
}

export function sincronizaNotasNacionalAdmin(municipio) {
    return request({
        url: `integracoes/municipio/${municipio}`,
        method: 'get'
    })
}
